/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.landscape\":[\"Sol och berg\"]}");